import { Component, effect, inject, signal } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { Header } from './shared/components/header/header';
import { Sidemenu } from './shared/components/sidemenu/sidemenu';
import { CommonModule } from '@angular/common';
import { EditorStateService } from './core/services/editor-state.service';
import { filter } from 'rxjs';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, Header, Sidemenu, CommonModule],
  templateUrl: './app.html',
})
export class App {
  protected readonly title = signal('rail-ui');


  isSidebarOpen = signal(true);
  isAssetsValidationPage = signal(false);
  private userPreferredSidebarState = true;
  protected editorState = inject(EditorStateService);
  private router = inject(Router);

  constructor() {
    // Auto-close sidebar on entering assets-validation screen
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      const isVal = event.urlAfterRedirects.includes('/assets-validation') || event.urlAfterRedirects.includes('/sip-validation');
      this.isAssetsValidationPage.set(isVal);
      if (isVal) {
        this.isSidebarOpen.set(false);
      } else {
        this.isSidebarOpen.set(this.userPreferredSidebarState);
      }
    });

    effect(() => {
      const isVal = this.isAssetsValidationPage();
      const isEditorOpen = this.editorState.isEditorOpen();
      if (isVal) {
        this.isSidebarOpen.set(false);
      } else {
        this.isSidebarOpen.set(!isEditorOpen);
      }
    });
  }

  toggleSidebar() {
    // Do not allow opening the sidebar if we are on the assets validation screen
    if (this.isAssetsValidationPage()) {
      this.isSidebarOpen.set(false);
      return;
    }
    this.isSidebarOpen.update(state => {
      const newState = !state;
      this.userPreferredSidebarState = newState;
      return newState;
    });
  }
}
